export const clickextension = { // eslint-disable-line
  bind: (el, binding) => {
    const element = el;
    const clickableElements = binding.value.split(',');
    const link = element.querySelector('a');
    el.style.cursor = 'pointer';

    clickableElements.forEach((elem) => {
      const currentElements = element.querySelectorAll(elem);
      if (currentElements) {
        Array.prototype.map.call(currentElements, (obj) => {
          obj.onclick = function () {
            link.click();
          };
        });
      }
    });
  },
};
